import { LoggedInUserData } from "./userData.model";

export class LoggedInUser {
  constructor(
    public auth: string,
    public userData: LoggedInUserData,
    public access_token: string,
  ) {}

  // get token() {
  //   // if(!this._tokenExpirationDate || new Date() > this._tokenExpirationDate) {
  //   //     return null;
  //   // }
  //   return this._access_token;
  // }
}
